exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-messages{color:maroon;font-weight:bolder}", ""]);

// exports
